import { Routes, Route } from 'react-router-dom';
import './Body.css';
import PersonModify from '../pages/person/modify';
import PersonAccount from '../pages/person/account'; // 필요시 추가
import PersonLogin from '../pages/person/login';
import PersonSignature from '../pages/person/signature'; // 필요시 추가
import TestingTeacherDocumentList from '../pages/testing_teacher_document/list';

const Body = () => {
  return (
    <main>
      <Routes>
        <Route path="/person/modify" element={<PersonModify />} />
        <Route path="/person/account" element={<PersonAccount />} />
        <Route path="/person/signature" element={<PersonSignature />} />
        <Route path="/person/login" element={<PersonLogin />} />
        <Route path="/testing_teacher_document/list" element={<TestingTeacherDocumentList />} />
        {/* 다른 라우트도 필요하면 여기에 추가 */}
      </Routes>
    </main>
  );
};

export default Body;

